export default "__VITE_ASSET__nJvUMknS__"